import React, { type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { type Appearance } from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';

/*
A custom button component for the footer of the JQL basic picker dropdown button
with a tooltip and custom alignment to the left
*/
export const LeftFooterButton = ({
	message,
	onClick,
	testId,
	appearance,
	hasTooltip,
}: {
	message: string;
	onClick: (mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	testId?: string;
	appearance: Appearance;
	hasTooltip: boolean;
}): React.JSX.Element => {
	const content = (
		<Button appearance={appearance} onClick={onClick} testId={testId}>
			{message}
		</Button>
	);

	if (!hasTooltip) {
		return (
			<Box padding="space.050" xcss={leftFooterButtonContainerStyles}>
				{content}
			</Box>
		);
	}

	return (
		<Box padding="space.050" xcss={leftFooterButtonContainerStyles}>
			<Tooltip content={message}>{content}</Tooltip>
		</Box>
	);
};

const leftFooterButtonContainerStyles = xcss({
	overflow: 'hidden',
	marginInlineStart: 'space.300',
});
